import React from 'react'
import { connect } from 'react-redux';
import { numberAddCommas } from 'servos/formValidations'
import Option from './Option'

class HomeLoan extends React.Component {
  render() {
    const { commitment } = this.props

    return (
      <div>
        <div className='big'>
          Home loan
        </div>
        <Option label='Address: '>
          {commitment.address}
        </Option>
        <Option label='Outstanding balance: '>
          {'$'+numberAddCommas(commitment.balance)}
        </Option>
        <Option label='Minimum monthly repayment: '>
          {'$'+numberAddCommas(commitment.repayment)}
        </Option>
        <Option label='Provider: '>
          {commitment.provider}
        </Option>
        { commitment.owner &&
          <Option label='Owner: '>
            {commitment.owner}
          </Option>
        }
        <hr/>
      </div>
    )
  }
}

export default HomeLoan
